import React from "react";
import "font-awesome/css/font-awesome.min.css";
import "./AboutPage.css";

export default function AboutPage() {
  return (
    <div>
      {/* <h3 className="center">
        <a
          href="https://twitter.com/intent/follow?screen_name=amehdaly&region=follow_link"
          target="_blank"
        >
          Follow me on Twitter
        </a>
      </h3>
      <h3 className="center">
        <a href="https://github.com/amehdaly" target="_blank">
          Check my Github
        </a>
      </h3> */}
      <div className="social-icons">
        <h6>Follow me on</h6>
        <br />
        <a
          href="https://youvote.netlify.app/"
          target="_blank"
          title="Would You Rather"
        >
          <i class="fa fa-delicious"></i>
        </a>

        <a href="https://github.com/amehdaly" target="_blank" title="github">
          <i className="fa fa-github-square" aria-hidden="true"></i>
        </a>

        <a
          href="https://twitter.com/intent/follow?screen_name=amehdaly&region=follow_link"
          target="_blank"
          title="twitter"
        >
          <i className="fa fa-twitter-square" aria-hidden="true"></i>
        </a>
      </div>
    </div>
  );
}
